import type { EnvironmentClass } from "../../api/types";

/**
 * Shared option lists for the environment forms, kept in one place so the
 * create and edit surfaces can never drift on which classes/node-types exist.
 * These mirror the closed sets the server validates against
 * (store.AllEnvironmentClasses, store.NodeTypeStandard/Local) — the server
 * remains the gate (S-8/S-19); this is only what the UI offers.
 */
export const ENVIRONMENT_CLASS_OPTIONS: ReadonlyArray<{ value: EnvironmentClass; label: string }> = [
  { value: "development", label: "Development" },
  { value: "preview", label: "Preview" },
  { value: "staging", label: "Staging" },
  { value: "production", label: "Production" },
];

export const NODE_TYPE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "standard", label: "Standard (managed host)" },
  { value: "local", label: "Local (developer machine)" },
];
